(function () {
	'use strict';

	angular
        .module('app')
        .factory('ContactService', ContactService);

	ContactService.$inject = ['EmailService'];

	function ContactService(EmailService) {
		var service = {
			getToolTipHtml: toolTipHtml,
			showContactInformation: showContactInformation,
			contactInvalid: contactInvalid
		};

		return service;

		/**
         *
         * Creates the html code to be shown for the contact tooltip
         *
         * @returns {string} html code describing the supplied contact
         */
		function toolTipHtml(contact) {
			return '<div class="contact-information" layout="column" layout-wrap>' + toolTipContactDetailsHtml(contact) + '</div>';
		}

		/**
		 *
		 * Checks the contact to determine if a tool tip shown be shown
		 *
		 * @returns {bool} does the contact contain information that needs to be shown in a tool tip
		 */
		function showContactInformation(contact) {
			var contactDetailsForTooltip = toolTipContactDetailsHtml(contact);
			return !_.isNil(contactDetailsForTooltip) && contactDetailsForTooltip !== '';
		}

		/**
		 *
		 * Determines if the contact information is invalid for the supplied contact.
		 * If so, the validation message will be returned. E.g. 'Email Address is blocked'.
		 *
		 * @returns {string} Returns a validation message if the contact is invalid, otherwise null if valid
		 */
		function contactInvalid(contact) {
			var result = null;

			if (contact.Usage === 'Email') {
				if (!contact.ReferenceContact && !_.isNil(contact.Value) && contact.Value !== '') {
					var emailValidation = EmailService.validateEmailAddress(contact.Value);

					if (!emailValidation.Valid) {
						result = emailValidation.Message;
					}
				}
			}

			return result;
		}

		/**
         *
         * Creates the html code for the contact details which are to be shown in a tool tip.
         * If nothing would be shown, an empty string is returned.
         *
         * @returns {string} html code describing the supplied contact details
         */
		function toolTipContactDetailsHtml(contact) {
		    var result = '';
		    if (_.isNil(contact))
		        return result;

		    result += '<div>' + contact.Name + '</div>';
		    result += '<div><strong>' + contact.Value + '</strong></div>';

			if (!_.isNil(contact.EntityDetails) && !_.isNil(contact.EntityDetails.Type) && contact.EntityDetails.Type !== '') {
				result += '<div><strong>Type:</strong> ' + contact.EntityDetails.Type + '</div>';
			}

			if (!_.isNil(contact.EntityDetails) && !_.isNil(contact.EntityDetails.Notes) && contact.EntityDetails.Notes !== '') {
				result += '<div><strong>Notes:</strong> ' + contact.EntityDetails.Notes + '</div>';
			}

			if (!_.isNil(contact) && !_.isNil(contact.Fax) && contact.Fax === true) {
				result += '<div><strong>Fax Supported</strong></div>';
			}

			if (!_.isNil(contact) && !_.isNil(contact.SMS) && contact.SMS === true) {
				result += '<div><strong>SMS Supported</strong></div>';
			}

			var contactInvalidMessage = contactInvalid(contact);
			if (!_.isNil(contactInvalidMessage)) {
				result += '<div class="error-messsage-div"><strong>' + contactInvalidMessage + '</strong></div>';
			}

			return result;
		}
	}
})();